import CardModifierComponent from '../../../../Component/Level/CardModifier';
import Container from '../../../Container';
import { Anim } from 'System/Animation/AnimationHelper';

export default class CardModifier extends Container {
    public onCreate(params: any): void {
        super.onCreate(params);
        this.addComponent<CardModifierComponent>(CardModifierComponent, params);
    }

    public static async preload(): Promise<void> {
        
    }

    public hideAndDestroy(): void {
        Anim(this, { alpha: 0, duration: 300 }).then(() => {
            this.destroy();
        });
    }
}
